import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { LocationService } from '@core/jss-seo';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { IconCardButtonComponent } from '@legacy/common-ui-utility-components';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { ScIconPipe } from '@core/jss-utils';

import { TaxonomyAccordionComponent } from './taxonomy-accordion/taxonomy-accordion.component';

@Component({
  selector: 'wl-taxonomy-container',
  templateUrl: './taxonomy-container.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    TrackImpressionDirective,
    JssModule,
    IconCardButtonComponent,
    AutomationIdDirective,
    TrackLinkDirective,
    TaxonomyAccordionComponent,
    ScIconPipe,
  ],
})
export class TaxonomyContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  selectedCategory: InnogyComponentRendering | undefined;

  constructor(private readonly locationService: LocationService) {}

  setSelectedCategory(category: InnogyComponentRendering): void {
    this.selectedCategory = category;
  }

  public navigateToLink(href: string | undefined): void {
    this.locationService.navigateGeneralLink(href || '');
  }
}
